export default __webpack_public_path__ + "static/media/aeps.b6fb865d.png";